import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import FirstPage from "./FirstPage";
import DocTable from "./DocTable";

const FeedbackReport = ({
  buildingName,
  start,
  end,
  feedbackTableData,
  complaintPieLink,
}) => {
  Font.register({
    family: "NotoSansTC",
    src: "/fonts/NotoSansTC-Regular.ttf",
  });

  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: 40,
      lineHeight: 1.5,
      fontSize: 14,
    },
    gap: {
      height: 20,
    },
    sectionTitle: {
      fontSize: 18,
      fontFamily: "Helvetica-Bold",
      marginTop: 5,
      marginBottom: 5,
    },
    visualHeader: {
      fontSize: 14,
      fontFamily: "Helvetica-Bold",
      textAlign: "center",
    },
    visualDescription: {
      marginTop: 5,
      fontSize: 11,
      textAlign: "right",
      color: "gray",
    },
  });

  return (
    <Document title="CBM Smart Toilet System Report" pageLayout="oneColumn">
      <FirstPage
        reportName={"Feedback"}
        buildingName={buildingName}
        start={start}
        end={end}
      />
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.sectionTitle} id="feedback">
            Feedback{" "}
          </Text>

          <Text style={styles.visualHeader}>Collected feedback</Text>
          <DocTable
            headers={["Description", "Rating", "Count"]}
            data={[
              {
                Description: "Poor",
                Rating: 1,
                Count: feedbackTableData["poor"],
              },
              {
                Description: "Average",
                Rating: 2,
                Count: feedbackTableData["average"],
              },
              {
                Description: "Good",
                Rating: 3,
                Count: feedbackTableData["good"],
              },
            ]}
          />

          <View style={styles.gap} />
          <Text style={styles.visualHeader}>Complaints by categories</Text>
          {complaintPieLink !== "" && (
            <Image src={complaintPieLink} cache={false}></Image>
          )}
          <Text style={styles.visualDescription}>
            * Feedbacks with rating of poor (1) is considered a complaint.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default FeedbackReport;
